import script from "./WorkBench.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkBench.vue?vue&type=script&setup=true&lang=js"

import "./WorkBench.vue?vue&type=style&index=0&id=63f19fd1&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f19fd1"]])

export default __exports__